'use strict';
const  DEPTH_LIMIT = 100,
	RectSet = require('./rect-set'),
	Offset = require('./offset');
module.exports = function PlacedRectSets(optional) {
	const self = this,
		depthLimit = (optional && optional.depthLimit) || DEPTH_LIMIT,
		placed = [],
		intersectionsOnPlacedRectSets = (rectSet) => {
			const rectSets = placed.map(p => p.intersectionsOnRectSet(rectSet));
			return new RectSet({rectSets});
		},
		offsetOnVectorRequiredToNotOverlap =  ({rectSet, appliedOffset, offsetDirection, depth}) => {
			if (!rectSet || !appliedOffset || !offsetDirection) {
				throw new Error('invalid-args');
			}
			const intersections = intersectionsOnPlacedRectSets(rectSet);
			if (intersections.isEmpty()) {
				return appliedOffset;
			} else {
				const additionalOffset = offsetDirection.multiply({
						x: intersections.boundingRect.width,
						y: intersections.boundingRect.height
					}),
					newDepth = (depth || 0) + 1,
					translatedRectSet = rectSet.translate(additionalOffset),
					newAppliedOffset = appliedOffset.add(additionalOffset);
				if (newDepth < depthLimit) {
					return offsetOnVectorRequiredToNotOverlap({rectSet: translatedRectSet, appliedOffset: newAppliedOffset, offsetDirection, depth: newDepth});
				} else {
					// TODO: maybe move immediately totally outside the bounding rect of everything placed
					return appliedOffset;
				}

			}
		},
		smallestOffset = (offset1, offset2, relatedToOffset) => {
			return (offset1.subtract(relatedToOffset).extension() < offset2.subtract(relatedToOffset).extension()) ? offset1 : offset2;
		},
		hasIntersectionsOnRectSet = (rectSet) => {
			return !!placed.find(p => p.hasIntersectionsOnRectSet(rectSet));
		};

	self.addPlacedRectSet = (rectSet) => {
		placed.push(rectSet);
	};

	self.translationRequiredToNotOverlap = ({rectSet, appliedOffset, movementOrigin}) => {
		if (!hasIntersectionsOnRectSet(rectSet)) {
			return appliedOffset;
		}
		const horizontalOffset = new Offset({x: Math.sign(appliedOffset.subtract(movementOrigin).x) || 1, y: 0}),
			verticalOffset = new Offset({x: 0, y: Math.sign(appliedOffset.subtract(movementOrigin).y) || 1}),
			horizontalOffsetRequired = offsetOnVectorRequiredToNotOverlap({rectSet, appliedOffset, offsetDirection: horizontalOffset}),
			verticalOffsetRequired = offsetOnVectorRequiredToNotOverlap({rectSet, appliedOffset, offsetDirection: verticalOffset});
		return smallestOffset(horizontalOffsetRequired, verticalOffsetRequired, appliedOffset);
	}; //{rectangles} = params;
	Object.freeze(Object.assign(this, {hasIntersectionsOnRectSet, placed, depthLimit}));
};
